import { AddressInput } from '@web/graphql-types'
import { createContext, useContext } from 'react'

export type ExtraFieldValues = { [key: string]: string }

export type ExtraFieldsState = {
  values: ExtraFieldValues
  onChange: (name: string, value: string) => void
  googleMapsApiKey?: string
  address?: AddressInput | null
  onAddressChange?: (address: AddressInput) => void
}

export const ExtraFieldsContext = createContext<ExtraFieldsState | null>(null)

export const useExtraFieldsContext = () => {
  const context = useContext(ExtraFieldsContext)

  if (!context) {
    throw new Error('No context set with useExtraFieldsContext')
  }

  return context
}

export const useOptionalExtraFieldsContext = () => useContext(ExtraFieldsContext)
